const VSLTheme = {
  palette: {
    mode: 'light',
    primary: {
      main: '#009BE0',
    },
    secondary: {
      main: '#1E1A56',
    },
    text: {
      primary: '#09294D',
      disabled: 'rgba(9,41,77,0.5)',
    },
    error: {
      main: '#d2003a',
    },
    warning: {
      main: '#f59f39',
    },
    info: {
      main: '#005faa',
    },
    success: {
      main: '#22c55e',
    },
    divider: 'rgba(30, 26, 86, 0.10)',
  },
  typography: {
    fontFamily: 'PT Sans',
    fontSize: 16,
    h1: {
      fontSize: '2.5rem',
      fontWeight: 700,
      lineHeight: 1.5,
    },
    h2: {
      fontSize: '1.5rem',
      fontWeight: 700,
      lineHeight: 1.25,
    },
    h3: {
      fontSize: '1.5rem',
    },
    button: {
      fontSize: 20,
      fontWeight: 700,
      textTransorm: 'none',
    },
  },
  components: {
    MuiCard: {
      styleOverrides: {
        root: {
          boxShadow: '0px 4px 20px 0px rgba(0, 0, 0, 0.10)',
          borderRadius: '0px',
          padding: '3.5rem'
        },
      },
    },
    MuiCardContent: {
      styleOverrides: {
        root: {
          paddingLeft: '0',
          paddingRight: '0'
        },
      },
    },
    MuiCardHeader: {
      styleOverrides: {
        root: {
          paddingTop: '0',
          paddingLeft: '0',
          paddingRight: '0'
        },
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          color: '#09294D',
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          border: '1px solid rgba(9, 41, 77, 0.20)',
          background: 'rgba(9, 41, 77, 0.04)',
          fontStyle: 'italic',
          color: 'rgba(9, 41, 77, 0.50)',
          borderRadius: 0,
          "&::placeholder": {
            fontStyle: 'italic',
            color: 'rgba(9, 41, 77, 0.50)'
          },
        },
      },
    },
    MuiAutoComplete: {
      styleOverrides: {
        root: {
          border: '1px solid rgba(9, 41, 77, 0.20)',
          background: 'rgba(9, 41, 77, 0.04)',
          fontStyle: 'italic',
          color: 'rgba(9, 41, 77, 0.50)',
          borderRadius: 0,
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          fontStyle: 'italic',
          color: 'rgba(9, 41, 77, 0.5)'
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        root: {
          border: '1px solid rgba(9, 41, 77, 0.20)',
          background: 'rgba(9, 41, 77, 0.04)',
          fontStyle: 'italic',
          color: 'rgba(9, 41, 77, 0.50)',
          borderRadius: 0,
        },
      },
    },
    MuiFormControl: {
      styleOverrides: {
        root: {
          marginTop: '0px !important',
          marginBottom: '.75rem',
        }
      }
    },
    MuiButton: {
      styleOverrides: {
        contained: {
          textTransform: 'none',
          padding: '.6rem 1rem',
          boxShadow: 'none',
          borderRadius: '0px',
          minWidth: '180px',
          '&:hover': {
            boxShadow: 'none',
          },
        },
        outlined: {
          textTransform: 'none',
          padding: '.6rem 1rem',
          boxShadow: 'none',
          borderRadius: '0px',
          '&:hover': {
            boxShadow: 'none',
          },
        },
      },
    },
  },
};
export default VSLTheme;